<div *ngIf="visible && showIcon" class="basket-button-container">
  <a id="basket" type="button" (click)="onClick()">
    <div class="svg-container" [inlineSVG]="'assets/svg/symbols/basket.svg'"></div>
  </a>
  <span *ngIf="count" class="count" (click)="onClick()">{{ count }}</span>
</div>
<div *ngIf="visible && !showIcon" class="basket-button-text">
  <a (click)="onClick()">
    {{ 'Shopping Basket' | translate }}
  </a>
</div>
